import CommonState from '@/class/cargo/model/parameters/CommonState'

export const DRAFT = new CommonState(0, '草稿', 'Draft')
export const ORDER_ISSUED = new CommonState(1, '已投保', 'Order issued')
export const CANCELLED = new CommonState(2, '已注销', 'Insured')
export const ISSUED = new CommonState(3, '已出单', 'Cancelled')
export const ISSUED_CANCELLED = new CommonState(4, '已注销', 'IssuedCancelled')

export const ORDER_GENERATE_STATUS = [DRAFT, ORDER_ISSUED, ISSUED, CANCELLED, ISSUED_CANCELLED]

// 出单状态
export const UNDER_INSURANCE = new CommonState(0, '投保中', 'Under Insurance')
export const NO_ORDER_ISSUED = new CommonState(0, '未出单', 'No Order Issued')
export const ISSUING_DRAFT = new CommonState(1, '草稿', 'Draft')
export const SUBMITTED = new CommonState(2, '已提交', 'Committed')
export const REJECTED = new CommonState(3, '已拒绝', 'Rejected')
export const ISSUED_ORDER = new CommonState(4, '已出单', 'Issued Order')
export const LOGGED_OUT = new CommonState(5, '已注销', 'Logged Out')

export const ISSUING_STATUS = [UNDER_INSURANCE, ISSUING_DRAFT, SUBMITTED, ISSUED_ORDER, REJECTED, LOGGED_OUT]
export const ISSUING_LIABILITY_STATUS = [NO_ORDER_ISSUED, ISSUED_ORDER]

export const CARGO_INSURANCE = new CommonState(1, '货运险', 'Cargo Insurance')
export const LIABILITY_INSURANCE = new CommonState(2, '责任险', 'Liability Insurance')

export const INSURANCE_TYPE = [CARGO_INSURANCE, LIABILITY_INSURANCE]

export const HTJJ = new CommonState('htjj', '华泰经纪', '华泰经纪')
export const KEBAO = new CommonState('kebao', '恪保', '恪保')
export const XNHB = new CommonState('xnhb', '小牛', '小牛')
export const LHB = new CommonState('lhb', '领航', '领航')
export const HGJ = new CommonState('hgj', '海管家', '海管家')
export const WSE = new CommonState('wse', '未斯', '未斯')
export const CW = new CommonState('cw', 'CargoWare', 'CargoWare')

export const INSURANCE_AGENT = [XNHB, HTJJ, KEBAO, LHB]
export const INQUIRY_INSURANCE_AGENT = [HTJJ, XNHB, LHB]
export const INSURANCE_NEW_AGENT = [XNHB, HTJJ, KEBAO]
export const INQUIRY_INSURANCE_NEW_AGENT = [HTJJ, XNHB]

export const TPYBX = new CommonState('tpybx', '太平洋保险', '太平洋保险')
export const ZGPA = new CommonState('zgpa', '中国平安', '中国平安')
export const ZGRB = new CommonState('zgrb', '中国人保', '中国人保')
export const ZGRS = new CommonState('zgrs', '中国人寿', '中国人寿')
export const YTCX = new CommonState('ytcx', '亚太财险', '亚太财险')
export const YGBX = new CommonState('ygbx', '阳光保险', '阳光保险')
export const DJHS = new CommonState('djhs', '东京海上', '东京海上')

export const INSURANCE_COMPANY = [TPYBX, ZGPA, ZGRB, ZGRS, YTCX, YGBX, DJHS]

// 精谕对应供应商配置
export const JY_EY = new CommonState('jyey', '精谕-恩原', '精谕-恩原')
export const JY_YJ = new CommonState('jyyj', '精谕-燕锦', '精谕-燕锦')
export const JY_JT = new CommonState('jyjt', '精谕-进通', '精谕-进通')
export const JY_ZW = new CommonState('jyzw', '精谕-中维', '精谕-中维')
export const JY_FW = new CommonState('jyfw', '精谕-凤威', '精谕-凤威')
export const JY_TS = new CommonState('jyts', '精谕-铁士', '精谕-铁士')
export const JY_HR = new CommonState('jyhr', '精谕-海润', '精谕-海润')
export const JY_YPT = new CommonState('jyypt', '精谕-易拼通', '精谕-易拼通')
export const JY_YM = new CommonState('jyym', '精谕-原牧', '精谕-原牧')
export const JY_YL = new CommonState('jyyl', '精谕-雅联', '精谕-雅联')

// export const OJ = new CommonState('OJ', '欧坚', 'Ou Jian')
// 平台供应商
export const INSURANCE_PLATFORM = [
  HTJJ, KEBAO, XNHB, LHB,
  TPYBX, ZGPA, ZGRB, ZGRS, YTCX, YGBX, DJHS, HGJ, WSE, CW, JY_EY, JY_YJ, JY_JT, JY_ZW, JY_FW, JY_TS, JY_HR, JY_YPT, JY_YM, JY_YL]

// 问卷状态 1已提交；2已接收
export const SUBMIT = new CommonState(1, '已提交', 'Submitted')
export const RECEIVED = new CommonState(2, '已接收', 'Received')

export const QUESTIONNAIRE_STATUS = [SUBMIT, RECEIVED]

// 联系方式 华泰，小牛，领航
export const CONCAT_HTJJ = new CommonState('htjj', '李先生 13582346273', '李先生 13582346273')
export const CONCAT_XNHB = new CommonState('xnhb', '陈经理 13564441031 | 021-61000872', '陈经理 13564441031 | 021-61000872')
export const CONCAT_LHB = new CommonState('lhb', '李日明 18120764759', '李日明 18120764759')

export const CONCAT_AGENTS = [CONCAT_HTJJ, CONCAT_XNHB, CONCAT_LHB]
